// extracted by mini-css-extract-plugin
export default {"form":"NoticeSettingsForm_form__odwvI","checkboxes":"NoticeSettingsForm_checkboxes__p6vUq","submitButton":"NoticeSettingsForm_submitButton__SbED5"};